import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()(() => ({
  countBox: {
    padding: "8px 10px",
    backgroundColor: "#EAE9E9",
    borderRadius: "4px",
    fontFamily: "poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#272525",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  countBoxTypo: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0px",
    color: "#272525",
    textTransform: "lowercase",
  },
  infoBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "20px 0",
    gap: "18px",
    flexWrap: "wrap",
  },
  infoText: {
    display: "flex",
    gap: "4px",
  },
  square: {
    width: 12,
    height: 12,
  },
  backgroundPersonal: {
    backgroundColor: "#AFD8FF",
  },
  backgroundGeneric: {
    backgroundColor: "#FFC5AF",
  },
  title: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0px",
    color: "#000000",
  },
}));

export default useStyle;
